import script from "./VisionModule5.vue?vue&type=script&setup=true&lang=js"
export * from "./VisionModule5.vue?vue&type=script&setup=true&lang=js"

import "./VisionModule5.vue?vue&type=style&index=0&id=6fe50045&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fe50045"]])

export default __exports__